import Permissions from '@app/src/auth/permissions'
import navigationLinks from '@app/src/wf-constants/navigationLinks'
import React from 'react'
import { useIntl } from 'react-intl'
import type { MenuLinkWrapperProps } from './LegacyMenuWrapper'
import { MenuLinkWrapper } from './LegacyMenuWrapper'
import type { NavbarItemProps } from './LegacyNavbarItems'

const SubscriptionLink: React.FC<NavbarItemProps> = ({ closeMenuDrawer }) => {
  const { formatMessage } = useIntl()

  const menuItems: MenuLinkWrapperProps['menuItems'] = {
    link: navigationLinks.transparencySubscriptions,
    permission: [Permissions.TRANSPARENCY_USER],
  }

  return (
    <MenuLinkWrapper
      closeMenuDrawer={closeMenuDrawer}
      menuItems={menuItems}
      title={formatMessage({ id: 'navbar.subscribers' })}
    />
  )
}

export default SubscriptionLink
